import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]
  static values = {
    devices: Array,
    persistedDevices: Array,
  }

  connect() {}

  addAllDevices(event) {
    event.preventDefault()
    this.devicesValue.forEach((device) => {
      if (!this.deviceAlreadyAdded(device)) {
        this.addDevice(device)
      }
    })
  }

  addDevice(device, hours = "") {
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    const fragment = document.createRange().createContextualFragment(content)

    const selectElement = fragment.querySelector('select[name*="[prefabricated_device]"]')
    const hoursInput = fragment.querySelector('input[name*="[own_hours]"]')

    if (selectElement) {
      const options = selectElement.options
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === device) {
          options[i].selected = true
          break
        }
      }
    }

    if (hoursInput) {
      hoursInput.value = hours
    }

    this.containerTarget.insertBefore(fragment, this.containerTarget.lastElementChild)
  }

  deviceAlreadyAdded(device) {
    const existingSelects = this.containerTarget.querySelectorAll(
      'select[name*="[prefabricated_device]"]',
    )
    for (let i = 0; i < existingSelects.length; i++) {
      if (existingSelects[i].value === device) {
        return true
      }
    }
    return false
  }
}
